import AgoraRTC from 'agora-rtc-sdk-ng';

export default {
  // if blur effect is active, set canvas as the video source
  async createVbackgroundTrack() {
    const canvas = document.querySelector('.virtual-bg-video');
    if (this.videoEffect !== 'none' && !this.constraints.screen && canvas) {
      // perform segmentation if canvas has no data yet (blur from device-setting)
      if (!canvas.hasAttribute('data-blur') || !this.videoDevice) {
        const segment = await this.virtualBackground.setProvider('agora').performSegmentation(this.videoDevice);
        if (!segment) {
          return;
        }
      }

      canvas.getContext('2d');
      const canvasVideoTrack = canvas.captureStream().getVideoTracks()[0];
      this.localVbackgroundTrack = AgoraRTC.createCustomVideoTrack({
        encoderConfig: this.videoProfile,
        mediaStreamTrack: canvasVideoTrack
      });
      this.localTracks.push(this.localVbackgroundTrack);
    } else {
      this.localTracks.push(this.localVideoTrack);
    }
  }
}
